'use client';

import React from 'react';
import styles from './SCarDetaiDescriptionSection.module.scss';
import SCarDetaiSwitch from '../Switch/SCarDetaiSwitch';

// 通用的金融方案显示组�?
const FinanceExampleDisplay = ({ title, items, isVisible = true }) => {
  if (!isVisible || !items || items.length === 0) return null;

  return (
    <>
      <h2 className={styles.subtitle}>{title}</h2>
      <div className={styles.financeBlock}>
        <div className={styles.financeTable}>
          {items.map((item, index) => (
            <div
              key={item.id || index}
              className={`${styles.financeRow} ${
                item.fields?.isHighlighted?.value ? styles.highlightRow : ''
              }`}
            >
              <div className={styles.label}>{item.fields?.label?.value}</div>
              <div className={styles.value}>{item.fields?.value?.value}</div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

const SCarDetaiDescriptionSection = ({ data, title, selectedIndex, onIndexChange }) => {
  if (!data || data.length === 0) {
    return (
      <section className={styles.descriptionSection} data-aos="fade-up">
        <p>No description data available.</p>
      </section>
    );
  }

  const selectedPackage = data[selectedIndex];

  const segmentedData = data.map((item, index) => ({
    index,
    title: item.fields?.title?.value?.toUpperCase() || `Package ${index + 1}`,
  }));

  const handleSegmentedClick = (index) => {
    onIndexChange(index);
  };

  return (
    <section className={styles.descriptionSection} data-aos="fade-up">
      <h1 className={styles.carTitle}>{title}</h1>

      {/* PCP标题在Switch上面，和老项目保持一�?*/}
      {selectedPackage?.fields?.pcpRepExampleTitle?.value && (
        <p className={styles.subtitle}>{selectedPackage.fields.pcpRepExampleTitle.value}</p>
      )}

      {data.length > 1 && (
        <div className={styles.features_segmented}>
          <SCarDetaiSwitch
            items={segmentedData}
            activeIndex={selectedIndex}
            onClick={handleSegmentedClick}
          />
        </div>
      )}

      {/* PCP Example - 不显示标题，因为已经在上面显示了 */}
      {selectedPackage?.fields?.pcpRepExampleItem?.length > 0 && (
        <div className={styles.financeBlock}>
          <div className={styles.financeTable}>
            {selectedPackage.fields.pcpRepExampleItem.map((item, index) => (
              <div
                key={item.id || index}
                className={`${styles.financeRow} ${
                  item.fields?.isHighlighted?.value ? styles.highlightRow : ''
                }`}
              >
                <div className={styles.label}>{item.fields?.label?.value}</div>
                <div className={styles.value}>{item.fields?.value?.value}</div>
              </div>
            ))}
          </div>
        </div>
      )}

      {/* HP Example - 使用硬编码标�?*/}
      <FinanceExampleDisplay
        title="Hire Purchase (HP) Representative Example"
        items={selectedPackage?.fields?.hpRepExample}
        isVisible={selectedPackage?.fields?.hpRepExample?.length > 0}
      />

      {/* PCH Example - 使用硬编码标�?*/}
      <FinanceExampleDisplay
        title="Personal Contract Hire (PCH) Representative Example"
        items={selectedPackage?.fields?.pchRepExample}
        isVisible={selectedPackage?.fields?.pchRepExample?.length > 0}
      />

      {/* BCH Example - 使用硬编码标�?*/}
      <FinanceExampleDisplay
        title="Business Contract Hire (BCH) Representative Example"
        items={selectedPackage?.fields?.bchRepExample}
        isVisible={selectedPackage?.fields?.bchRepExample?.length > 0}
      />
    </section>
  );
};

export default SCarDetaiDescriptionSection;
